// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDAAPVnX2MqEFWNPwJqCeOntNDXrjcpCMA",
  authDomain: "peopletag-demo-1.firebaseapp.com",
  projectId: "peopletag-demo-1",
  storageBucket: "peopletag-demo-1.firebasestorage.app",
  messagingSenderId: "510075152291",
  appId: "1:510075152291:web:3fb36d161448934079dc16"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };